export default __webpack_public_path__ + "static/media/biometry.810a56a8.png";